class ApiError extends Error {
  constructor(axiosError, ...params) {
    super(...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError);
    }

    this.name = 'ApiError';
    this.message = axiosError.message;
    this.date = new Date();

    if (axiosError.response) {
      this.response = axiosError.response;
    }

    if (axiosError.request) {
      this.request = axiosError.request;
    }

    // eslint-disable-next-line no-console
    console.error('axiosError', axiosError.message);
  }
}

export default ApiError;
